define('home/views/ChannelLeadersEmptyView',[
    'backbone-marionette',

    'core/strings',

    'home/templates/channelLeadersEmpty',
], function (
    Marionette,

    strings,

    channelLeadersEmptyTemplate
) {
    'use strict';

    var gettext = strings.get;

    /**
     * The empty view for when one of the tabs in the ChannelLeadersModuleView
     * is empty.
     * Expects to be passed the type of leaders which is empty, either leaders
     * (top contributors) or mods (moderators).
     */
    var ChannelLeadersEmptyView = Marionette.ItemView.extend({
        template: channelLeadersEmptyTemplate,
        templateHelpers: function () {
            return {
                message: this.constructor.MESSAGES[this.type],
            };
        },

        initialize: function (options) {
            this.type = options.type;
        },
    }, {
        MESSAGES: {
            leaders: gettext('No top contributors yet'),
            mods: gettext('No moderators yet'),
        },
    });

    return ChannelLeadersEmptyView;
});

